import Colors from '../../components/colors'

const init = () => {
  Colors()
}

export default init
